import { render } from "./DiscussionPagination.vue?vue&type=template&id=fb77e608&scoped=true"
import script from "./DiscussionPagination.vue?vue&type=script&lang=js"
export * from "./DiscussionPagination.vue?vue&type=script&lang=js"

import "./DiscussionPagination.vue?vue&type=style&index=0&id=fb77e608&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb77e608"]])

export default __exports__